// extracted by mini-css-extract-plugin
module.exports = {"container":"PageSection_container__Z5CUQ","image":"PageSection_image__ezGSn","title":"PageSection_title__It5oz"};